module.exports = __webpack_public_path__ + "static/media/closedIcon.9f546131.svg";